/**
 * File-type badge for a filename.
 *
 * Extracted verbatim from PartEntryPage's local `getFileTypeBadge` so the parts
 * Files card and the new component Files card cannot drift apart. Import it in
 * both rather than keeping two copies.
 */
export function getFileTypeBadge(filename) {
  if (!filename) return { label: '???', color: 'bg-secondary' };

  const ext = filename.split('.').pop().toLowerCase();

  switch (ext) {
    case 'pdf': return { label: 'PDF', color: 'bg-danger' };
    case 'dxf':
    case 'dwg': return { label: ext.toUpperCase(), color: 'bg-dark' };
    case 'step':
    case 'stp': return { label: 'STEP', color: 'bg-info text-dark' };
    case 'igs':
    case 'iges': return { label: 'IGES', color: 'bg-info text-dark' };
    case 'png':
    case 'jpg':
    case 'jpeg': return { label: 'IMG', color: 'bg-success' };
    case 'xls':
    case 'xlsx':
    case 'csv': return { label: 'EXCEL', color: 'bg-success' };
    case 'doc':
    case 'docx': return { label: 'DOC', color: 'bg-primary' };
    default: return { label: ext.toUpperCase().substring(0, 4), color: 'bg-secondary' };
  }
}

/**
 * What each component document type is FOR, in the operator's words. Shown as
 * the select's option label so nobody has to guess whether a purchase print is
 * a "drawing" or a "spec".
 */
export const COMPONENT_DOC_TYPES = [
  { value: 'drawing', label: 'Drawing — what the vendor builds to' },
  { value: 'model',   label: 'Model — STEP / DXF / CAD file' },
  { value: 'spec',    label: 'Spec — written requirements' },
  { value: 'cert',    label: 'Cert — material or compliance certificate' },
  { value: 'photo',   label: 'Photo — what the item looks like' },
  { value: 'quote',   label: 'Quote — vendor pricing paperwork' },
  { value: 'other',   label: 'Other' },
];

export function docTypeLabel(value) {
  const hit = COMPONENT_DOC_TYPES.find((t) => t.value === value);
  return hit ? hit.label.split(' — ')[0] : (value || 'Other');
}
